<template>
    <aside class="sidebar">
        <li v-for="side in sidebarList" :key="side.key" class="sidebar--item" @click.stop="handleSideClick(side)">
            <img :src="require(`@/assets/img/psq/create/${side.key}.png`)" alt="question-icon" class="question-icon"/>
            <span>{{ side.text }}</span>
        </li>
    </aside>
</template>

<script>
import QUESTION_DATA from "@/utils/question-config";

export default {
    name: "Aside",
    data() {
        return {
            sidebarList: Object.freeze(QUESTION_DATA.concat([{ key: "textDesc", val: "textDesc", text: "文本描述" }]))
        }
    },
    methods: {
        handleSideClick (side) {
            this.$emit("onSideClick", side)
        }
    }
}
</script>

<style scoped lang="less">
.question-icon {
    vertical-align: middle;
    margin-right: 10px;
}
.sidebar {
    width: 320px;
    min-width: 320px;
    font-size: 16px;
    padding: 50px 30px;
    background-color: #fff;
    height: calc(100vh - 70px - 70px);
    max-height: calc(100vh - 70px - 70px);
    overflow-x: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    &--item {
        margin-bottom: 10px;
        border-radius: 6px;
        border: 1px solid #E5E8EC;
        padding: 10px 30px;
        cursor: pointer;
    }
}
</style>
